import { render, staticRenderFns } from "./ChartBoxComponent.vue?vue&type=template&id=0f77622a"
import script from "./ChartBoxComponent.vue?vue&type=script&lang=js"
export * from "./ChartBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports